import React from "react";
import Jumbotron from "../components/Jumbotron";
import CallToAction from "../components/CallToAction";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";
import {
	Element,
	animateScroll as scroll,
	scrollSpy,
	scroller
} from "react-scroll";

import styles from "../styles/faq.module.scss";

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

class FAQ extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentCat: "latest",

			loadMore: true
		};
	}
	componentDidMount() {
		const hashCategory = this.props.location.hash.slice(1);
		// alert(hashCategory);
		// scroller.scrollTo(hashCategory);

		scroller.scrollTo(hashCategory, {
			duration: 500,
			delay: 100,
			smooth: true,
			offset: -100 // Scrolls to element + 50 pixels down the page
		});
	}

	render() {
		const { transition, data } = this.props;
		const faqArray = data.allContentfulFaq.edges;
		const cta = data.allContentfulCallToAction.edges[0].node;
		const pageSettings = data.contentfulFaqPage;

		const items = faqArray.map((question, i) => {
			function createMarkup() {
				return {
					__html: question.node.answer.childMarkdownRemark.html
				};
			}

			return (
				<Element
					key={"question-" + (i + 1)}
					name={question.node.slug}
					className="element"
				>
					<div className={"row " + styles.faq_item}>
						<div
							className={
								"col-12 col-lg-10 " + styles.faq_item_inner
							}
						>
							<b className={styles.h4}>
								{question.node.question}
							</b>
							<div dangerouslySetInnerHTML={createMarkup()} />
						</div>
					</div>
				</Element>
			);
		});
		return (
			<PageWrapper
				locale={pageSettings.node_locale}
				location={this.props.location}
				data={data.layout.edges[0].node}
			>
				<main role="main" style={transition && transition.style}>
					<Helmet title={pageSettings.pageTitle} />
					<Jumbotron
						type="jumbotron_b"
						bottomLine={true}
						className="mb-0"
						textAlign="text-center"
						contentAlign="justify-content-md-center"
					>
						<h1>{pageSettings.pageTitle}</h1>
					</Jumbotron>

					<div className={"container " + styles.faq_list}>
						{items}
					</div>
					<div className="grey_bg py-4">
						<CallToAction
							className="my-5"
							text={cta.content.childMarkdownRemark.html}
							buttonLabel={cta.buttonLabel}
							destination={`/${pageSettings.node_locale}${
								cta.linkTo
							}`}
							arrow={true}
						/>
					</div>
				</main>
			</PageWrapper>
		);
	}
}

export default FAQ;

export const query = graphql`
	query FAQPageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		contentfulFaqPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		allContentfulFaq(filter: { node_locale: { eq: $locale } }) {
			edges {
				node {
					id
					slug
					question
					answer {
						childMarkdownRemark {
							html
						}
					}
					node_locale
				}
			}
		}

		allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "faq" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/faq-template.js